function renderFootnoteSymbol(token) {
  let superscriptElement = document.createElement('SUP');
  let textNode = document.createTextNode(token.text);
  superscriptElement.appendChild(textNode);
  return [superscriptElement];
}

function renderFootnoteLines(footnoteLinesToken, renderContext, renderTokenElements) {
  let div = document.createElement('DIV');
  div.classList.add('canopy-footnotes');
  let horizonalRule = document.createElement('HR');
  horizonalRule.classList.add('canopy-footnote-rule');
  div.appendChild(horizonalRule);

  footnoteLinesToken.lines.forEach(line => {
    let footnoteSpan = document.createElement('SPAN');
    footnoteSpan.classList.add('canopy-footnote-span');
    let textNode = document.createTextNode(line.superscript + '. ');
    footnoteSpan.appendChild(textNode);
    line.tokens.forEach((token) => {
      let [tokenElement] = renderTokenElements(token, renderContext);
      footnoteSpan.appendChild(tokenElement);
    });

    div.appendChild(footnoteSpan);
  });

  let lineBreakSpan = document.createElement('SPAN');
  lineBreakSpan.classList.add('canopy-linebreak-span');

  return [div, lineBreakSpan];
}

export {
  renderFootnoteSymbol,
  renderFootnoteLines
};
